import { render, staticRenderFns } from "./Ghidorah.vue?vue&type=template&id=293cae56&scoped=true&"
import script from "./Ghidorah.vue?vue&type=script&lang=js&"
export * from "./Ghidorah.vue?vue&type=script&lang=js&"
import style0 from "./Ghidorah.vue?vue&type=style&index=0&id=293cae56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293cae56",
  null
  
)

export default component.exports